// extracted by mini-css-extract-plugin
export default {"helpTextNoIcon":"HelperText_helpTextNoIcon__in9Ny","helpText":"HelperText_helpText__LsZF9"};